import React from 'react'

const EmailSent = () => {
  return (
    <div>Sent</div>
  )
}

export default EmailSent